import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCarrier } from 'API/Carriers/updateCarrier';

const useUpdateCarrier = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (carrierData) => {
        const response = await updateCarrier(carrierData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['Carriers'] });
            queryClient.invalidateQueries({
                queryKey: ['Carrier', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateCarrier;
